/** *************************************************************
 * Return if the default for a particular state should be med or rec
 ************************************************************** */
export function medRecDefault(state) {
  switch (state) {
    case "CA":
    case "NV":
    case "OR":
    case "WA":
      return "Recreational";
    case "AZ":
    case "AR":
    case "CT":
    case "DE":
    case "FL":
    case "HI":
    case "LA":
    case "MD":
    case "MN":
    case "MO":
    case "MT":
    case "NH":
    case "NJ":
    case "NY":
    case "NM":
    case "ND":
    case "OH":
    case "OK":
    case "PA":
    case "RI":
    case "WV":
    case "UT":
      return "Medical";
    default:
      return null;
  }
}

/** *************************************************************
 * Category Icons
 ************************************************************** */
export function categoryIcon(name) {
  if (name == "Plant Material") {
    return "bushel-plant-material";
  }
  if (name == "Prepack") {
    return "bushel-flower-circle";
  }
  if (name == "Preroll") {
    return "bushel-flower-circle";
  }
  if (name == "Seed") {
    return "bushel-plant-material";
  }
  if (name == "Clone") {
    return "bushel-plant-material";
  }
  if (name == "Bulk Extract") {
    return "bushel-extracts";
  }
  if (name == "Extract") {
    return "bushel-extracts";
  }
  if (name == "Cartridge") {
    return "bushel-cartridge";
  }
  if (name == "Topicals & Wellness") {
    return "bushel-topical";
  }
  if (name == "Merchandise") {
    return "bushel-merchandise";
  }
  if (name == "Edibles & Drink") {
    return "bushel-edibles";
  }
  if (name == "Tincture") {
    return "bushel-cartridge";
  }
  if (name == "bushel-biomass") {
    return "bushel-flower-circle";
  }
  if (name == "Pack To Order") {
    return "bushel-flower-circle";
  }
  return "bushel-biomass";
}

/** *************************************************************
 * Product Icons
 ************************************************************** */
export function productIcon(name) {
  if (name == "Plant Material") {
    return "bushel-product-plant-material";
  }
  if (name == "Prepack") {
    return "bushel-product-prepack";
  }
  if (name == "Preroll") {
    return "bushel-product-preroll";
  }
  if (name == "Seed") {
    return "bushel-product-seed";
  }
  if (name == "Clone") {
    return "bushel-product-clone";
  }
  if (name == "Live Plant") {
    return "bushel-product-clone";
  }
  if (name == "Bulk Extract") {
    return "bushel-product-bulk-extracts";
  }
  if (name == "Extract") {
    return "bushel-product-extracts";
  }
  if (name == "Cartridge") {
    return "bushel-product-cartridge";
  }
  if (name == "Merchandise") {
    return "bushel-product-merchandise";
  }
  if (name == "Edibles & Drink") {
    return "bushel-product-edibles";
  }
  if (name == "Tincture") {
    return "bushel-product-tincture";
  }
  if (name == "Topicals & Wellness") {
    return "bushel-product-health-wellness";
  }
  if (name == "Pack To Order") {
    return "bushel-product-pack-to-order";
  }
  if (name == "bushel-product-biomass") {
    return "bushel-biomass";
  }
  return "bushel-product-clone";
}

// I don't believe this is used. It also breaks app engineering goals by requiring
// updates here and in db, so we should not use it.
// If still after 10/16/20, anyone who sees it may delete it.
// export function stateDisplay(input, to = 'abbr'){
//
//   var states = [
//       ['Arizona', 'AZ'],
//       ['Alabama', 'AL'],
//       ['Alaska', 'AK'],
//       ['Arkansas', 'AR'],
//       ['California', 'CA'],
//       ['Colorado', 'CO'],
//       ['Connecticut', 'CT'],
//       ['Delaware', 'DE'],
//       ['Florida', 'FL'],
//       ['Georgia', 'GA'],
//       ['Hawaii', 'HI'],
//       ['Idaho', 'ID'],
//       ['Illinois', 'IL'],
//       ['Indiana', 'IN'],
//       ['Iowa', 'IA'],
//       ['Kansas', 'KS'],
//       ['Kentucky', 'KY'],
//       ['Louisiana', 'LA'],
//       ['Maine', 'ME'],
//       ['Maryland', 'MD'],
//       ['Massachusetts', 'MA'],
//       ['Michigan', 'MI'],
//       ['Minnesota', 'MN'],
//       ['Mississippi', 'MS'],
//       ['Missouri', 'MO'],
//       ['Montana', 'MT'],
//       ['Nebraska', 'NE'],
//       ['Nevada', 'NV'],
//       ['New Hampshire', 'NH'],
//       ['New Jersey', 'NJ'],
//       ['New Mexico', 'NM'],
//       ['New York', 'NY'],
//       ['North Carolina', 'NC'],
//       ['North Dakota', 'ND'],
//       ['Ohio', 'OH'],
//       ['Oklahoma', 'OK'],
//       ['Oregon', 'OR'],
//       ['Pennsylvania', 'PA'],
//       ['Rhode Island', 'RI'],
//       ['South Carolina', 'SC'],
//       ['South Dakota', 'SD'],
//       ['Tennessee', 'TN'],
//       ['Texas', 'TX'],
//       ['Utah', 'UT'],
//       ['Vermont', 'VT'],
//       ['Virginia', 'VA'],
//       ['Washington', 'WA'],
//       ['West Virginia', 'WV'],
//       ['Wisconsin', 'WI'],
//       ['Wyoming', 'WY'],
//   ];
//
//   if (to == 'abbr'){
//       input = input.replace(/\w\S*/g, function(txt){
//           return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
//       });
//
//       for(var i = 0; i < states.length; i++){
//           if(states[i][0] == input){
//               return(states[i][1]);
//           }
//       }
//   } else if (to == 'name'){
//       input = input.toUpperCase();
//
//       for(i = 0; i < states.length; i++){
//           if(states[i][1] == input){
//               return(states[i][0]);
//           }
//       }
//   }
// };
